<template>
  <div id="app-layout">
    <v-app>
      <div id="inbowaware-nav-drawer" class="d-flex flex-row">
        <app-drawer
          :isDrawerOpen="isDrawerOpen"
          @toggle-drawer="toggleDrawer"
        />
      </div>

      <div id="inboxaware-header">
        <app-header @toggle-drawer="toggleDrawer" />
      </div>

      <v-main id="main-section" class="">
        <v-container fluid class="px-5 py-4 px-md-8 py-md-6">
          <transition name="fade" mode="out-in">
            <!--------------- Renders vue routes  --------------->
            <router-view />
          </transition>
        </v-container>
      </v-main>
      <snackbar
        :snackbarValue="snackbar.value"
        :snackBarIcon="snackbar.icon"
        :snackBarType="snackbar.type"
        @close="closeSnackbar"
      >
        <div class="d-flex justify-end">
          <span class="text--primary body-2 white-space-preline">
            {{ snackbar.message }}
          </span>
        </div>
      </snackbar>
    </v-app>
  </div>
</template>

<script>
import AppDrawer from "./AppDrawer.vue";
import AppHeader from "./AppHeader.vue";
import { Snackbar } from "@/components/shared";
import { mapGetters, mapActions } from "vuex";

/**
 * Default layout of the application
 */
export default {
  name: "AppLayout",
  /**
   * ---------------- Components ------------------
   */
  components: {
    AppDrawer,
    AppHeader,
    Snackbar,
  },
  /**
   * ---------------- Data properties ------------------
   */
  data: () => ({
    isDrawerOpen: false,
  }),
  /**
   * ---------------- Computed properties ------------------
   */
  computed: {
    ...mapGetters({
      snackbar: "ui/snackbar",
    }),
  },
  methods: {
    ...mapActions({
      setSnackbar: "ui/setSnackbar",
    }),
    /**
     * Toggles left drawer navigation on the basis of the isDrawer props
     */
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
    /**
     * Closes the snackbar and dispactches the action in the store
     */
    closeSnackbar(value) {
      const data = { value, message: "", previousError: this.snackbar.message };

      this.setSnackbar(data);
    },
  },
};
</script>
